<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="loading && !selectedLcData">
        <v-col cols="12" class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-2">Loading...</p>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header mb-4">
                LC Shipment Create Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form ref="shipmentForm">
                  <v-row>
                    <!-- Left Column: LC Selection & Shipment Info -->
                    <v-col md="3" cols="12">
                      <v-expansion-panels v-model="panel1" multiple>
                        <v-expansion-panel>
                          <v-expansion-panel-title class="panel-header mb-4">LC Selection & Shipment Info</v-expansion-panel-title>
                          <v-expansion-panel-text>
                            <v-autocomplete
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="lc_id.value.value"
                                :items="getLcImportLcMasterList"
                                :item-title="item => `${item.lc_no} - ${item.code || ''}`"
                                item-value="id"
                                :error-messages="lc_id.errorMessage.value"
                                @update:modelValue="loadLcData"
                                clearable
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                              <template #label>
                                Select LC <span class="text-red-accent-4">*</span>
                              </template>
                            </v-autocomplete>



                            <v-date-input
                                input-format="dd/mm/yyyy"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="shipment_date.value.value"
                                :error-messages="shipment_date.errorMessage.value"
                                label="Shipment Date"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                required
                            >
                              <template #label>
                                Shipment Date <span class="text-red-accent-4">*</span>
                              </template>
                            </v-date-input>

                            <v-autocomplete
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="loading_port_id.value.value"
                                :items="getLcPortList"
                                :item-title="(item) => `${item.code} - ${item.name}`"
                                item-value="id"
                                label="Loading Port"
                                clearable
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                            <v-autocomplete
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="discharge_port_id.value.value"
                                :items="getLcPortList"
                                :item-title="(item) => `${item.code} - ${item.name}`"
                                item-value="id"
                                label="Discharge Port"
                                clearable
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                            <v-date-input
                                input-format="dd/mm/yyyy"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="etd.value.value"
                                label="ETD (Estimated Time of Departure)"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                clearable
                            ></v-date-input>

                            <v-date-input
                                input-format="dd/mm/yyyy"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="eta.value.value"
                                label="ETA (Estimated Time of Arrival)"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                clearable
                            ></v-date-input>

                            <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="carrier.value.value"
                                label="Carrier"
                                clearable
                            ></v-text-field>

                            <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="bl_no.value.value"
                                label="BL No"
                                clearable
                            ></v-text-field>

                            <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="container_no.value.value"
                                label="Container No"
                                clearable
                            ></v-text-field>

                            <v-textarea
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="remarks.value.value"
                                label="Remarks"
                                rows="3"
                            ></v-textarea>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>

                    <!-- Right Column: LC Information & Shipment Items -->
                    <v-col md="9" cols="12">
                      <!-- LC Information -->
                      <v-card variant="outlined" class="mb-3">
                        <v-card-title class="text-subtitle-1 bg-grey-lighten-4">
                          LC Information
                        </v-card-title>
                        <v-card-text>
                          <div v-if="!selectedLcData" class="text-center py-4">
                            <v-alert type="info" variant="tonal">
                              Please select an LC to view information
                            </v-alert>
                          </div>
                          <v-row v-else>
                            <v-col cols="6" md="3">
                              <div class="text-caption text-grey">LC No</div>
                              <div class="text-body-2">{{ selectedLcData.lc_no || '-' }}</div>
                            </v-col>
                            <v-col cols="6" md="3">
                              <div class="text-caption text-grey">LC Date</div>
                              <div class="text-body-2">{{ selectedLcData.lc_open_date || '-' }}</div>
                            </v-col>
                            <v-col cols="6" md="3">
                              <div class="text-caption text-grey">LC Code</div>
                              <div class="text-body-2">{{ selectedLcData.code || '-' }}</div>
                            </v-col>
                            <v-col cols="6" md="3">
                              <div class="text-caption text-grey">Supplier</div>
                              <div class="text-body-2">{{ selectedLcData.supplier?.supplier_name || '-' }}</div>
                            </v-col>
                            <v-col cols="6" md="3">
                              <div class="text-caption text-grey">LC Amount</div>
                              <div class="text-body-2">{{ formatCurrency(selectedLcData.lc_amount) }}</div>
                            </v-col>
                            <v-col cols="6" md="3">
                              <div class="text-caption text-grey">Currency</div>
                              <div class="text-body-2">{{ selectedLcData.currency?.code || '-' }}</div>
                            </v-col>
                            <v-col cols="6" md="3">
                              <div class="text-caption text-grey">LC Status</div>
                              <div class="text-body-2">
                                <v-chip size="small" :color="getLcStatusColor(selectedLcData.lc_status)">
                                  {{ selectedLcData.lc_status || '-' }}
                                </v-chip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>

                      <!-- Shipment Items Section - Always Visible -->
                      <v-card variant="outlined" class="mb-3">
                        <v-card-title class="bg-grey-lighten-4">
                          Shipment Items
                        </v-card-title>
                        <v-card-text>
                          <div v-if="!selectedLcData">
                            <v-alert type="info" variant="tonal" prominent>
                              Please select an LC to view and select shipment items
                            </v-alert>
                          </div>

                          <div v-else-if="!selectedLcData.pis || selectedLcData.pis.length === 0">
                            <v-alert type="info" variant="tonal" prominent>
                              No PIs found for this LC. Please add PIs to the LC first.
                            </v-alert>
                          </div>

                          <div v-else>
                            <div v-for="(pi, piIndex) in selectedLcData.pis" :key="`pi-${pi.id}`" class="mb-4">
                              <v-card variant="outlined" class="mb-3">
                                <v-card-title class="text-subtitle-1 bg-grey-lighten-4">
                                  PI: {{ pi.pi_no || pi.code }} - {{ formatDateView(pi.pi_date) }}
                                </v-card-title>
                                <v-card-text>
                                  <v-data-table
                                      :headers="shipmentItemHeaders"
                                      :items="getPiItemsForShipment(pi)"
                                      density="compact"
                                      class="elevation-0"
                                      :items-per-page="-1"
                                      hide-default-footer
                                  >
                                    <template v-slot:item.product="{ item }">
                                      {{ item.product?.name || '-' }} ({{ item.product?.code || '-' }})
                                    </template>
                                    <template v-slot:item.hs_code="{ item }">
                                      {{ item.hs_code }}
                                    </template>
                                    <template v-slot:item.original_qty="{ item }">
                                      {{ formatNumber(item.qty) }}
                                    </template>

                                    <template v-slot:item.already_shipped="{ item }">
                                      {{ formatNumber(getAlreadyShippedQty(item.id)) }}
                                    </template>

                                    <template v-slot:item.remaining_qty="{ item }">
                                      <span :class="getRemainingQty(item.id) <= 0 ? 'text-red' : ''">
                                        {{ formatNumber(getRemainingQty(item.id)) }}
                                      </span>
                                    </template>

                                    <template v-slot:item.shipment_qty="{ item }">
                                      <v-text-field
                                          v-model="getShipmentItem(item.id).qty"
                                          type="number"
                                          density="compact"
                                          variant="outlined"
                                          :max="getRemainingQty(item.id)"
                                          :min="0"
                                          :step="0.01"
                                          @update:model-value="updateShipmentItem(item)"
                                          @blur="updateShipmentItem(item)"
                                          style="max-width: 120px;"
                                      ></v-text-field>
                                    </template>

                                    <template v-slot:item.rate="{ item }">
                                      <v-text-field
                                          v-model="getShipmentItem(item.id).rate"
                                          type="number"
                                          density="compact"
                                          variant="outlined"
                                          :min="0"
                                          :step="0.01"
                                          @update:model-value="updateShipmentItem(item)"
                                          @blur="updateShipmentItem(item)"
                                          style="max-width: 120px;"
                                          readonly
                                      ></v-text-field>
                                    </template>

                                    <template v-slot:item.amount="{ item }">
                                      {{ formatCurrency(getShipmentItem(item.id).amount) }}
                                    </template>

                                    <template v-slot:item.select="{ item }">
                                      <v-checkbox
                                          v-model="getShipmentItem(item.id).selected"
                                          @update:model-value="updateShipmentItem(item)"
                                          density="compact"
                                          hide-details
                                      ></v-checkbox>
                                    </template>
                                  </v-data-table>
                                </v-card-text>
                              </v-card>
                            </div>

                            <v-alert
                                v-if="selectedItems.length === 0"
                                type="warning"
                                variant="tonal"
                                class="mt-3"
                            >
                              Please select at least one item for shipment.
                            </v-alert>

                            <v-card variant="outlined" class="mt-3" v-if="selectedItems.length > 0">
                              <v-card-title class="text-subtitle-1 bg-grey-lighten-4">
                                Shipment Summary
                              </v-card-title>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="12" md="6">
                                    <div class="text-body-2">
                                      <strong>Total Items:</strong> {{ selectedItems.length }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <div class="text-body-2">
                                      <strong>Total Shipment Value:</strong> {{ formatCurrency(totalShipmentValue) }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>

                            <!-- Action Buttons -->
                            <v-row class="mt-3">
                              <v-col cols="12">
                                <div class="d-flex justify-end" style="gap: 12px;">
                                  <v-btn
                                      class="bg-grey-darken-1"
                                      variant="flat"
                                      type="button"
                                      v-if="status.value.value !== 1"
                                      :loading="submitting && currentStatus === 0"
                                      :disabled="submitting && currentStatus !== 0 || selectedItems.length === 0"
                                      @click="submitForm(0)"
                                  >
                                    DRAFT
                                  </v-btn>
                                  <v-btn
                                      class="bg-primary"
                                      variant="flat"
                                      type="button"
                                      :loading="submitting && currentStatus === 1"
                                      :disabled="submitting && currentStatus !== 1 || selectedItems.length === 0"
                                      @click="submitForm(1)"
                                  >
                                    POST
                                  </v-btn>
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import { formatDateView, formatDateDash } from "@/plugins/helpers";

export default {
  methods: {
    formatDateView,
  },
  setup() {
    const { handleSubmit, resetForm: resetFormValidation } = useForm({
      validationSchema: yup.object({
        lc_id: yup.number().positive().integer().required().label("LC"),
        shipment_date: yup.date().required().label("Shipment Date"),
      }),
    });

    const lc_id = useField("lc_id");
    const shipment_date = useField("shipment_date");
    const loading_port_id = useField("loading_port_id");
    const discharge_port_id = useField("discharge_port_id");
    const etd = useField("etd");
    const eta = useField("eta");
    const carrier = useField("carrier");
    const bl_no = useField("bl_no");
    const container_no = useField("container_no");
    const remarks = useField("remarks");
    const status = useField("status");

    const panel = ref([0]);
    const panel1 = ref([0]);
    const panel2 = ref([0]);
    const loading = ref(false);
    const submitting = ref(false);
    const currentStatus = ref(0);
    const selectedLcData = ref(null);
    const existingShipments = ref([]);
    const shipmentItems = ref({}); // Key: pi_detail_id, Value: { selected, qty, rate, amount }

    // Edit mode state
    const isEditMode = ref(false);
    const editShipmentId = ref(null);
    const editShipmentData = ref(null); // raw response from getLcImportLcShipmentById, used to seed items once LC is loaded

    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const getLcImportLcMasterList = computed(() => {
      return store.getters.getLcImportLcMasterList || [];
    });

    const getLcPortList = computed(() => {
      return store.getters.getLcPortList || [];
    });

    const shipmentItemHeaders = [
      { title: "Select", key: "select", align: "center", sortable: false, width: "5%" },
      { title: "Product", key: "product", align: "left", sortable: false, width: "20%"  },
      { title: "Unit", key: "product.unit.name", align: "left", sortable: false, width: "10%"  },
      { title: "HS Code", key: "hs_code", align: "left", sortable: false, width: "10%"  },
      { title: "Original Qty", key: "original_qty", align: "right", sortable: false },
      { title: "Already Shipped", key: "already_shipped", align: "right", sortable: false },
      { title: "Remaining Qty", key: "remaining_qty", align: "right", sortable: false },
      { title: "Shipment Qty", key: "shipment_qty", align: "center", sortable: false, width: "15%" },
      { title: "Rate", key: "rate", align: "center", sortable: false, width: "15%"  },
      { title: "Amount", key: "amount", align: "right", sortable: false },
    ];

    const getPiItemsForShipment = (pi) => {
      if (!pi || !pi.details) return [];
      return pi.details.map(item => ({
        ...item,
        pi_master_id: pi.id,
      }));
    };

    const getAlreadyShippedQty = (piDetailId) => {
      if (!existingShipments.value || existingShipments.value.length === 0) return 0;

      let totalShipped = 0;
      existingShipments.value.forEach(shipment => {
        // In edit mode, exclude the shipment currently being edited from "already shipped"
        // so its own items don't count against their own remaining quantity.
        if (isEditMode.value && editShipmentId.value && shipment.id === editShipmentId.value) {
          return;
        }
        const items = shipment.shipment_items || shipment.shipmentItems || [];
        items.forEach(item => {
          if (item.proforma_invoice_details_id === piDetailId) {
            totalShipped += parseFloat(item.received_qty || item.qty || 0);
          }
        });
      });
      return totalShipped;
    };

    const getRemainingQty = (piDetailId) => {
      const item = findPiDetailItem(piDetailId);
      if (!item) return 0;
      const originalQty = parseFloat(item.qty) || 0;
      const alreadyShipped = getAlreadyShippedQty(piDetailId);
      return Math.max(0, originalQty - alreadyShipped);
    };

    const findPiDetailItem = (piDetailId) => {
      if (!selectedLcData.value || !selectedLcData.value.pis) return null;
      for (const pi of selectedLcData.value.pis) {
        if (pi.details) {
          const item = pi.details.find(d => d.id === piDetailId);
          if (item) return item;
        }
      }
      return null;
    };

    const getShipmentItem = (piDetailId) => {
      if (!shipmentItems.value[piDetailId]) {
        const item = findPiDetailItem(piDetailId);
        shipmentItems.value[piDetailId] = {
          selected: false,
          qty: 0,
          rate: item ? (parseFloat(item.rate) || 0) : 0,
          amount: 0,
          proforma_invoice_master_id: null,
          proforma_invoice_details_id: piDetailId,
          product_id: item ? item.product_id : null,
        };
      }
      // shipmentItems.value[piDetailId].qty = getRemainingQty(piDetailId);
      return shipmentItems.value[piDetailId];
    };

    const updateShipmentItem = (item) => {
      const shipmentItem = getShipmentItem(item.id);

      // Set PI master ID and product ID if not set
      if (!shipmentItem.proforma_invoice_master_id) {
        shipmentItem.proforma_invoice_master_id = item.pi_master_id;
      }
      if (!shipmentItem.product_id) {
        shipmentItem.product_id = item.product_id;
      }

      // Update rate from original item if not manually changed
      if (shipmentItem.rate === 0 && item.rate) {
        shipmentItem.rate = parseFloat(item.rate) || 0;
      }

      // Calculate amount
      const qty = parseFloat(shipmentItem.qty) || 0;
      const rate = parseFloat(shipmentItem.rate) || 0;
      shipmentItem.amount = qty * rate;

      // Validate qty doesn't exceed remaining
      const remaining = getRemainingQty(item.id);
      if (qty > remaining) {
        shipmentItem.qty = remaining;
        shipmentItem.amount = remaining * rate;
        toast.warning(`Quantity cannot exceed remaining quantity (${remaining})`);
      }
    };

    const selectedItems = computed(() => {
      return Object.values(shipmentItems.value).filter(item =>
          item.selected && item.qty > 0
      );
    });

    const totalShipmentValue = computed(() => {
      return selectedItems.value.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
    });

    // Apply the saved shipment's items on top of the freshly-initialized shipmentItems map.
    // Called after loadLcData() has populated selectedLcData + default shipmentItems.
    const applyEditShipmentItems = () => {
      if (!editShipmentData.value) return;

      const savedItems = editShipmentData.value.shipment_items || editShipmentData.value.shipmentItems || [];
      savedItems.forEach((saved) => {
        const piDetailId = saved.proforma_invoice_details_id;
        if (!piDetailId) return;

        // Ensure an entry exists (in case the PI detail wasn't found via findPiDetailItem)
        const existing = getShipmentItem(piDetailId);

        existing.selected = true;
        existing.qty = parseFloat(saved.qty) || 0;
        existing.rate = parseFloat(saved.rate) || 0;
        existing.amount = parseFloat(saved.amount) || (existing.qty * existing.rate);
        existing.proforma_invoice_master_id = saved.proforma_invoice_master_id || existing.proforma_invoice_master_id;
        existing.product_id = saved.product_id || existing.product_id;

        shipmentItems.value[piDetailId] = existing;
      });
    };

    const loadLcData = async (lcId) => {
      if (!lcId) {
        selectedLcData.value = null;
        existingShipments.value = [];
        shipmentItems.value = {};
        return;
      }

      try {
        loading.value = true;

        // Load LC data
        const lcData = await store.dispatch('getLcImportLcMasterById', lcId);
        selectedLcData.value = lcData;

        if(loading_port_id.value.value == null) loading_port_id.value.value = lcData.loading_port_id;
        if(discharge_port_id.value.value == null) discharge_port_id.value.value = lcData.discharge_port_id;

        // Load existing shipments for this LC to calculate already shipped quantities
        try {
          const shipmentsResponse = await store.dispatch('getLcImportLcShipmentList');
          existingShipments.value = (shipmentsResponse.data?.data || []).filter(
              shipment => shipment.lc_id === lcId
          );
        } catch (error) {
          console.warn('Failed to load existing shipments:', error);
          existingShipments.value = [];
        }

        // Initialize shipment items
        shipmentItems.value = {};
        if (lcData.pis && lcData.pis.length > 0) {
          lcData.pis.forEach(pi => {
            if (pi.details) {
              pi.details.forEach(item => {
                shipmentItems.value[item.id] = {
                  selected: false,
                  qty: (item.qty - getAlreadyShippedQty(item.id)),
                  rate: parseFloat(item.rate) || 0,
                  amount: ((item.qty - getAlreadyShippedQty(item.id)) * (parseFloat(item.rate) || 0)),
                  proforma_invoice_master_id: pi.id,
                  proforma_invoice_details_id: item.id,
                  product_id: item.product_id,
                };
              });
            }
          });
        }

        // If we're editing an existing shipment, overlay its saved item selections/qty/rate
        // now that the default items map has been built for this LC.
        if (isEditMode.value && editShipmentData.value) {
          applyEditShipmentItems();
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to load LC data');
      } finally {
        loading.value = false;
      }
    };

    const formatNumber = (num) => {
      if (!num && num !== 0) return "0.00";
      return Number(num).toFixed(2);
    };

    const formatCurrency = (amount) => {
      if (!amount && amount !== 0) return "0.00";
      const currencySymbol = selectedLcData.value?.currency?.symbol || '';
      return currencySymbol ? `${currencySymbol} ${Number(amount).toFixed(2)}` : Number(amount).toFixed(2);
    };

    const getLcStatusColor = (status) => {
      const colors = {
        'Open': 'info',
        'Shipped': 'success',
        'Closed': 'grey',
      };
      return colors[status] || 'default';
    };

    const toYmd = (val) => {
      if (!val) return null;
      // If string like '2025-12-17T18:00:00.000Z', keep only date part
      if (typeof val === "string") {
        return val.split("T")[0];
      }
      const d = new Date(val);
      if (Number.isNaN(d.getTime())) return null;
      return d.toISOString().split("T")[0];
    };

    // Load an existing shipment for editing, populate form fields, then load its LC
    // (which in turn overlays the saved item selections via applyEditShipmentItems).
    const loadShipmentForEdit = async (shipmentId) => {
      if (!shipmentId) return;

      loading.value = true;
      try {
        const response = await store.dispatch('getLcImportLcShipmentById', shipmentId);
        const data = response?.data || response;

        if (!data) {
          toast.error('Failed to load shipment data');
          return;
        }

        editShipmentData.value = data;

        // Populate simple fields
        shipment_date.value.value = data.shipment_date || null;
        loading_port_id.value.value = data.loading_port_id || null;
        discharge_port_id.value.value = data.discharge_port_id || null;
        etd.value.value = data.etd || null;
        eta.value.value = data.eta || null;
        carrier.value.value = data.carrier || null;
        bl_no.value.value = data.bl_no || null;
        container_no.value.value = data.container_no || null;
        remarks.value.value = data.remarks || null;
        currentStatus.value = data.status ?? 0;
        status.value.value = data.status ?? 0

        // Setting lc_id triggers loadLcData via v-autocomplete's @update:modelValue only on user
        // interaction, not on programmatic set, so call it explicitly here.
        lc_id.value.value = data.lc_id || null;
        if (data.lc_id) {
          await loadLcData(data.lc_id);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to load shipment data');
      } finally {
        loading.value = false;
      }
    };

    const resetForm = () => {
      resetFormValidation();
      selectedLcData.value = null;
      existingShipments.value = [];
      shipmentItems.value = {};
      lc_id.value.value = null;
      shipment_date.value.value = null;
      loading_port_id.value.value = null;
      discharge_port_id.value.value = null;
      etd.value.value = null;
      eta.value.value = null;
      carrier.value.value = null;
      bl_no.value.value = null;
      container_no.value.value = null;
      remarks.value.value = null;
    };

    const submitForm = async (btnStatus) => {
      currentStatus.value = btnStatus;

      // Validate required fields
      if (!lc_id.value.value || !shipment_date.value.value) {
        toast.error("Please fill in required fields (LC, Shipment No, Shipment Date)");
        return;
      }

      // Backend requires items for both Draft and Post
      if (selectedItems.value.length === 0) {
        toast.error("Please select at least one item for shipment");
        return;
      }

      submitting.value = true;
      try {
        const formData = {
          lc_id: lc_id.value.value,
          shipment_date: toYmd(shipment_date.value.value),
          loading_port_id: loading_port_id.value.value || null,
          discharge_port_id: discharge_port_id.value.value || null,
          etd: toYmd(etd.value.value) || null,
          eta: toYmd(eta.value.value) || null,
          carrier: carrier.value.value || null,
          bl_no: bl_no.value.value || null,
          container_no: container_no.value.value || null,
          remarks: remarks.value.value || null,
          status: btnStatus, // 0 for Draft, 1 for Post
          items: selectedItems.value.map(item => ({
            proforma_invoice_master_id: item.proforma_invoice_master_id,
            proforma_invoice_details_id: item.proforma_invoice_details_id,
            product_id: item.product_id,
            qty: parseFloat(item.qty),
            rate: parseFloat(item.rate),
          })),
        };

        if (isEditMode.value && editShipmentId.value) {
          formData.id = editShipmentId.value;
        }

        await store.dispatch('saveUpdateLcImportLcShipment', formData);
        toast.success(btnStatus === 0 ? "Shipment saved as draft successfully" : "Shipment posted successfully");
        router.push({ name: 'lc-import-lc-shipment-records' });
      } catch (error) {
        toast.error(error.response?.data?.message || `Failed to ${btnStatus === 0 ? 'save draft' : 'post shipment'}`);
      } finally {
        submitting.value = false;
      }
    };

    onMounted(async () => {
      // Load initial data
      await store.dispatch('getLcImportLcMasterList', {type: 'lc_for_shipment'});
      await store.dispatch('getLcPortList');
      await store.dispatch('getLcImportLcShipmentList');

      if (route.params.id) {
        isEditMode.value = true;
        editShipmentId.value = route.params.id;
        await loadShipmentForEdit(route.params.id);
      }
    });

    return {
      panel,
      panel1,
      panel2,
      loading,
      submitting,
      selectedLcData,
      lc_id,
      shipment_date,
      loading_port_id,
      discharge_port_id,
      etd,
      eta,
      status,
      carrier,
      bl_no,
      container_no,
      remarks,
      getLcImportLcMasterList,
      getLcPortList,
      shipmentItemHeaders,
      getPiItemsForShipment,
      getAlreadyShippedQty,
      getRemainingQty,
      getShipmentItem,
      updateShipmentItem,
      selectedItems,
      totalShipmentValue,
      loadLcData,
      formatNumber,
      formatCurrency,
      getLcStatusColor,
      submitForm,
      currentStatus,
      resetForm,
      isEditMode,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>